const DeliveryStatus = Object.freeze({
    DELIVERED: { value: 'delivered', text: 'Delivered' },
    RESERVED: { value: 'reserved', text: 'Reserved' },
    DRAFT: { value: 'draft', text: 'Draft' },
    SCHEDULED: { value: 'scheduled', text: 'Scheduled to send' },
    DISCONTINUED: { value: 'discontinued', text: 'Discontinued' },
});

export default DeliveryStatus;
